import React, { useState } from 'react';
import { Button, Modal } from '@themesberg/react-bootstrap';
import CronSchedulerUI from './CronSchedulerUI';

const ScheduleModal = ({ show, onHide, initialValue, onSave, title }) => {
  // console.log(initialValue);
  const [schedule, setSchedule] = useState(initialValue || {});

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CronSchedulerUI value={schedule} onChange={setSchedule} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => onSave(schedule)}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ScheduleModal;
